module.exports = __webpack_public_path__ + "static/img/cash.b51cbb9.png";